module.exports = __webpack_public_path__ + "static/media/theme-classic-small.21482d82.png";